<template>
  <v-app>
    <v-toolbar app>
      <span
        ><img
          :src="require('../assets/images/logo_notext.png')"
          alt="logo"
          style="cursor: pointer"
          contain
          class="shrink mr-2 cursor-change"
          transition="scale-transition"
          width="40"
      /></span>
      <v-toolbar-title class="headline">
        <span
          >North Saskatchewan Watershed Alliance Hydrology Explorer</span
        >
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "Landing",
};
</script>

<style scoped>
.lowercase {
  text-transform: lowercase;
  font-size: 20px;
}
</style>
